import {TRemitterInfo} from './types';
import {TList, TResponse, TUUID} from '@/types';
import CancelablePromise from 'mn-utils/CancelablePromise';
import {apiRequestAdmin} from '../../../../ws';
import {
  getNiumRemitterInfo,
  getNiumRemitterList,
} from './mock';

import {
  ENDPOINT_ADMIN_PO_NIUM_REMITTER_ADD,
  ENDPOINT_ADMIN_PO_NIUM_REMITTER_UPDATE,
  ENDPOINT_ADMIN_PO_NIUM_REMITTER_LIST,
  ENDPOINT_ADMIN_PO_NIUM_REMITTER_GET
} from '../../../../../constants/api';


// Добавляет отправителя
export function apiAdminPayoutNiumRemitterAdd(params: TRemitterInfo): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_PO_NIUM_REMITTER_ADD;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

// Обновляет данные по отправителю
export function apiAdminPayoutNiumRemitterUpdate(params: TRemitterInfo): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_PO_NIUM_REMITTER_UPDATE;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

// Возвращает список активных конфигураций "отправителей"
export function apiAdminPayoutNiumRemitterList(): Promise<TList<TRemitterInfo>> {
  const url = ENDPOINT_ADMIN_PO_NIUM_REMITTER_LIST;

  if (process.env.MOCK) {
    const response = {
      list: getNiumRemitterList(10),
      count: 10,
    };
    console.info({url, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url);
}

// Получить конфигурацию по отправителю
export function apiAdminPayoutNiumRemitterGet(params: {nium_account_id: TUUID}): Promise<TRemitterInfo> {
  const url = ENDPOINT_ADMIN_PO_NIUM_REMITTER_GET;

  if (process.env.MOCK) {
    const response = getNiumRemitterInfo();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}
